function footerAccordion() {
  const sections = document.querySelectorAll('.FooterNav-section');

  sections.forEach((section) => {
    const title = section.querySelector('.FooterNav-sectionTitle');

    if (title) {
      title.addEventListener('click', (e) => {
        // if (in dekstop) return;
        e.preventDefault();

        const isOpen = section.classList.contains('FooterNav-section--open');

        document.querySelectorAll('.FooterNav-section--open').forEach((openSection) => {
          openSection.classList.remove('FooterNav-section--open');
        });

        if (!isOpen) {
          section.classList.add('FooterNav-section--open');
        }

        updateAccordions();
      });
    }
  });
}


function updateAccordions() {
  const sections = document.querySelectorAll('.FooterNav-section');

  sections.forEach((section) => {
    const menus = section.querySelector('.FooterNav-menus');
    const isOpen = section.classList.contains('FooterNav-section--open');

    if (menus) {
      if (isOpen) {
        menus.style.maxHeight = menus.scrollHeight + 'px';
      } else {
        menus.style.maxHeight = null;
      }
    }
  });
}